import { jsx } from '@amzn/shiv'

export function ErrorMessage(props: { message: string }) {
    return <div className="errorMessage">{props.message}</div>
}
